export interface CmmdRuntimeThreadWorkspace {
  readonly worktreePath: string | null;
}

export function encodeCmmdRuntimeThreadWorkspaceMetadata(
  workspace: CmmdRuntimeThreadWorkspace,
): Readonly<Record<string, unknown>> {
  return { forgeWorkspace: { schemaVersion: 1, worktreePath: workspace.worktreePath } };
}

export function decodeCmmdRuntimeThreadWorkspaceMetadata(
  metadata: Readonly<Record<string, unknown>> | null | undefined,
): CmmdRuntimeThreadWorkspace | null {
  const value = metadata?.["forgeWorkspace"];
  if (typeof value !== "object" || value === null || Array.isArray(value)) return null;
  const workspace = value as Readonly<Record<string, unknown>>;
  const path = workspace["worktreePath"];
  if (workspace["schemaVersion"] !== 1) return null;
  if (path !== null && (typeof path !== "string" || path.trim().length === 0)) return null;
  return { worktreePath: path };
}
